import {
  intlShape,
  loginContainer,
  ProgressTick,
  SubmitButton,
  utils,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';

import ModifiedAsterisk from './ModifiedAsterisk';
import ReloadButton from './ReloadButton';
import styles from './SaveDeleteButtons.less';
import ScreenRemoveButton from './ScreenRemoveButton';
import ScreenResetButton from './ScreenResetButton';

export const I18N = defineMessages({
  ADD: {
    id: 'autoLayout.button.add',
    defaultMessage: 'Add',
    description: 'title text for auto layout add button',
  },
  SAVE: {
    id: 'autoLayout.button.save',
    defaultMessage: 'Save',
    description: 'title text for auto layout save button',
  },
});

class SaveDeleteButtons extends React.PureComponent {
  render() {
    const {
      intl,
      isCollapsed,
      isDirty,
      isDisabled,
      isInvalid,
      isLoading,
      isNew,
      isRemoving,
      isSaving,
      onAdd,
      onDelete,
      onReset,
      onReload,
      onSave,
    } = this.props;
    return (
      <div
        className={classNames(
          styles.dlSaveDeleteButtons,
          'form-group',
          'text-end'
        )}
        hidden={isCollapsed}
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {isInvalid ? (
          <ReloadButton
            className={[styles.dlSaveDeleteButtonsButton]}
            isLoading={isLoading}
            onReload={onReload}
          />
        ) : isNew ? (
          <>
            <ScreenResetButton isDisabled={isDisabled} onReset={onReset} />
            <SubmitButton
              className={classNames(
                styles.dlSaveDeleteButtonsButton,
                'btn-primary'
              )}
              dataName={'addScreenButton'}
              onClick={onAdd}
              disabled={isDisabled}
              title={utils.TranslateUtils.translate(I18N.ADD, intl)}
            >
              <i
                className={classNames(styles.dlButtonIcon, 'fas fa-plus fa-fw')}
              />
              <span className={styles.dlBoldText}>
                <FormattedMessage {...I18N.ADD} />
              </span>
            </SubmitButton>
          </>
        ) : (
          <>
            <ScreenRemoveButton
              isDisabled={isDisabled}
              onDelete={onDelete}
              isRemoving={isRemoving}
            />
            <ScreenResetButton isDisabled={isDisabled} onReset={onReset} />
            <SubmitButton
              className={styles.dlSaveDeleteButtonsButton}
              dataName={'saveButton'}
              onClick={onSave}
              disabled={isDisabled}
              title={utils.TranslateUtils.translate(I18N.SAVE, intl)}
            >
              <ProgressTick progressCounter={+isSaving}>
                <i
                  className={classNames(
                    styles.dlButtonIcon,
                    'fas fa-save fa-fw'
                  )}
                />
                <span className={styles.dlBoldText}>
                  <FormattedMessage {...I18N.SAVE} />
                </span>
              </ProgressTick>
            </SubmitButton>
          </>
        )}
        <ModifiedAsterisk isModified={isDirty} />
      </div>
    );
  }
}

SaveDeleteButtons.displayName = 'SaveDeleteButtons';

SaveDeleteButtons.propTypes = {
  onDelete: PropTypes.func,
  onReload: PropTypes.func,
  onReset: PropTypes.func,
  onSave: PropTypes.func,
  onAdd: PropTypes.func,
  intl: intlShape.isRequired,
  isCollapsed: PropTypes.bool,
  isDirty: PropTypes.bool,
  isNew: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isLoading: PropTypes.bool,
  isRemoving: PropTypes.bool,
  isSaving: PropTypes.bool,
};

SaveDeleteButtons.defaultProps = {
  onDelete: undefined,
  onReload: undefined,
  onReset: undefined,
  onSave: undefined,
  onAdd: undefined,
  isCollapsed: false,
  isDirty: false,
  isNew: false,
  isDisabled: false,
  isInvalid: false,
  isLoading: false,
  isRemoving: false,
  isSaving: false,
};

export default injectIntl(SaveDeleteButtons);
